/**
 * gatsby-browser.js
 *
 * Keeps <html lang> in sync during client-side navigations and
 * forces Klaro to re-render so the cookie consent UI matches
 * the current locale.
 */

exports.onRouteUpdate = ({ location }) => {
  // Derive locale from the pathname, same logic as gatsby-ssr.js
  const match = (location.pathname || '/').match(/^\/([a-z]{2})(\/|$)/)
  const lang = match ? match[1] : 'en'

  // Update <html lang> — gatsby-ssr only sets this at build time,
  // so client-side navigations between locales need this manual update.
  document.documentElement.lang = lang

  // Re-render Klaro so it picks up the new lang from document.documentElement.lang
  if (window.klaro && window.klaroConfig) {
    window.klaro.render(window.klaroConfig)
  }
}
